import React, { useState, useEffect, useRef } from 'react';
import { Modal, Toast, ToastContainer, Spinner } from 'react-bootstrap';

import { useNotifications } from '../../common/hooks/useNotifications';
import { useSpdCore } from '../../common/hooks/useSpdCore';

export type StatusType = 'online' | 'offline';
type HangingPromise = () => void;

export default () => {
  const notifications = useNotifications();
  const spd = useSpdCore();
  const [show, setShow] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [autohide, setAutohide] = useState(false);
  const [connectionText, setConnectionText] = useState<string>();
  const hangingPromisesRef = useRef<HangingPromise[]>([]);
  const onlineRef = useRef(true);

  useEffect(() => {
    function onlineHandler() {
      setConnectionText('☀️ Połączenie przywrócone');
      setAutohide(true);
      setShowModal(false);
    }

    function offlineHandler() {
      setConnectionText(
        '⛈️ Kłopoty z połączeniem - dane mogą nie zostać zapisane!',
      );
      setAutohide(false);
      setShow(true);
      setShowModal(true);
    }

    window.addEventListener('online', onlineHandler);
    window.addEventListener('offline', offlineHandler);

    return () => {
      window.removeEventListener('online', onlineHandler);
      window.removeEventListener('offline', offlineHandler);
    };
  }, []);

  useEffect(() => {
    notifications.online = () => {
      setConnectionText('☀️ Połączenie przywrócone');
      setAutohide(true);
      setShow(true);
      setShowModal(true);
      onlineRef.current = true;

      if (hangingPromisesRef.current.length > 0) {
        setShowModal(false);

        for (const hangingResolve of hangingPromisesRef.current) {
          hangingResolve();
        }
        hangingPromisesRef.current = [];
      }
    };

    notifications.offline = () => {
      setConnectionText(
        '⛈️ Kłopoty z połączeniem - dane mogą nie zostać zapisane!',
      );
      setAutohide(false);
      setShow(true);
      setShowModal(true);
      onlineRef.current = false;
    };
  }, [notifications, spd]);

  return (
    <>
      {show && (
        <ToastContainer className="p-3">
          <Toast
            onClose={() => setShow(false)}
            show={show}
            autohide={autohide}
            delay={5000}
            bg="light"
          >
            <Toast.Body className="text-center">{connectionText}</Toast.Body>
          </Toast>
        </ToastContainer>
      )}
      <Modal
        centered={true}
        backdrop="static"
        show={showModal}
        className="modal-on-modal"
        backdropClassName="modal-on-modal-backdrop"
      >
        <Modal.Header>
          <Modal.Title>Czekamy na przywrócenie połączenia...</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <Spinner animation="grow" variant="danger" />
          <Spinner animation="grow" variant="warning" />
          <Spinner animation="grow" variant="info" />
        </Modal.Body>
      </Modal>
    </>
  );
};
